/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";


import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";
import ReactMarkdown from "react-markdown";


// const data = {
//   retailCard: {
//     title: {
//       /**
//        * allows one-line in english, otherwise the rest is not aligned
//        * make it bigger if the
//        */
//       en: <span className="text-[32px]">Sell more, stress less</span>,
//       fr: <>Commerçants{X.Nbsp}?</>,
//     },
//     text: {
//       en: "Are you a retailer? Join us and offer easy VAT refunds to your customers. We'll take care of the rest!",
//       fr: "Proposez la détaxe à vos clients (sans contrainte). On s'occupe du reste !",
//     },
//     cta: {
//       en: "Discover our solution",
//       fr: "Découvrez notre solution",
//     },
//   },
// };


export function RatingsSection(props: X.PageProps) {
  return (
    <section className="mt-10 xl:my-20">
      <Desktop locale={props.locale} />
      <MobileRetailCard locale={props.locale} />
    </section>
  );
}


function Desktop(props: X.PageProps) {
  return (
    <div className={X.clsx(
      X.desktopOnly("flex"),
      "max-w-content mx-auto flex-row gap-10",
    )}>
      <DesktopRatingsCard locale={props.locale} />
      <DesktopRetailCard locale={props.locale} />
    </div>
  );
}


function DesktopRatingsCard(props: X.PageProps) {
  // const tr = X.useTranslator();

  const ratingCard = useTravelerHomePage('ratingCard')

  return (
    <div className="flex-1 bg-black text-white p-8 rounded-xl flex flex-col items-center gap-6">
      <div className="text-[24px] [&_strong]:font-semibold text-nowrap leading-tight -mb-1">
        <ReactMarkdown>
          {ratingCard.subTitle}
        </ReactMarkdown>
      </div>
      <X.AppRatings locale={props.locale} ratingCard={ratingCard} />
    </div>
  );
}


function DesktopRetailCard(_props: X.PageProps) {
  // const tr = X.useTranslator();
  const retailerCard = useTravelerHomePage('retailerCard')
  return (
    <div className="flex-1 flex flex-row items-stretch gap-4">
      <div className="flex-grow flex flex-col justify-between">
        {/* <h3 className="text-[36px] font-medium mb-2 pt-4 leading-tight">
          {tr(data.retailCard.title)}
          {retailerCard.title}
        </h3> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <h3 {...props} className="text-[36px] font-medium mb-2 pt-4 leading-tight" />,
          h1: ({ ...props }) => <h3 {...props} className="text-[36px] font-medium mb-2 pt-4 leading-tight" />,
          h2: ({ ...props }) => <h3 {...props} className="text-[36px] font-medium mb-2 pt-4 leading-tight" />,
          h3: ({ ...props }) => <h3 {...props} className="text-[36px] font-medium mb-2 pt-4 leading-tight" />,
          h4: ({ ...props }) => <h3 {...props} className="text-[36px] font-medium mb-2 pt-4 leading-tight" />,
        }}>
          {retailerCard.title}
        </ReactMarkdown>
        {/* <p className="text-[20px] mb-8 leading-tight">
          {tr(data.retailCard.text)}
          {retailerCard.content}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[20px] mb-8 leading-tight" />
        }}>
          {retailerCard.content}
        </ReactMarkdown>
        <div className="flex flex-col items-start">
          <X.Button
            secondary href="/retail"
            // label={tr(data.retailCard.cta)}
            label={retailerCard.cta}
            lg
          />
        </div>
      </div>

      <div className="relative w-full h-[248px]">
        <X.Image
          src={retailerCard.picture.url}
          fill
          alt="Merchants"
          className="object-cover object-center rounded-xl"
          unoptimized
        />
      </div>

      {/* <X.Image
        // src={MerchantsDesktopImage}
        src={retailerCard.picture.url}
        width={retailerCard.picture.width}
        height={retailerCard.picture.height}
        alt="Merchants"
        className="h-[248px] w-auto"
        unoptimized
      /> */}
    </div>
  );
}


function MobileRetailCard(_props: X.PageProps) {
  // const tr = X.useTranslator();

  //return (
  //<div className={X.clsx(X.mobileOnly(), "mx-mobile-margin")}>
  //<h3 className="text-[30px] font-medium mb-2">
  //{tr(data.retailCard.title)}
  //</h3>

  //<div className="flex flex-row gap-4 items-center">
  //<p className="text-[18px]">
  //{tr(data.retailCard.text)}
  //</p>
  //<X.Image
  //src={MerchantsMobileImage}
  //alt="Merchants"
  //className="h-auto w-[100px]"
  ///>
  //</div>

  //<div className="flex flex-col items-start mt-2">
  //<X.Button
  //secondary href="/retail"
  //label={tr(data.retailCard.cta)}
  ///>
  //</div>
  //</div>
  //);

  const retailerCard = useTravelerHomePage('retailerCard')
  /*
   * NOTE: this version sucks when the mobile screen is < 390px, or the text too long
   *
   * updated to respect the design...
   */
  return (
    <div className={X.clsx(X.mobileOnly(), "mx-mobile-margin")}>
      {/* <h3 className="text-[30px] font-medium mb-2">
        {tr(data.retailCard.title)}
        {retailerCard.title}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[30px] font-medium  [&_strong]:font-bold mb-2" />,
        h1: ({ ...props }) => <h3 {...props} className="text-[30px] font-medium  [&_strong]:font-bold mb-2" />,
        h2: ({ ...props }) => <h3 {...props} className="text-[30px] font-medium  [&_strong]:font-bold mb-2" />,
        h3: ({ ...props }) => <h3 {...props} className="text-[30px] font-medium  [&_strong]:font-bold mb-2" />,
        h4: ({ ...props }) => <h3 {...props} className="text-[30px] font-medium  [&_strong]:font-bold mb-2" />
      }}>
        {retailerCard.title}
      </ReactMarkdown>

      <div className="flex flex-row justify-between gap-4 items-stretch flex-shrink-0 flex-grow-0">
        <div className="flex flex-col items-start gap-6 ">
          {/* <p className="text-[16px] leading-tight">
            {tr(data.retailCard.text)}
            {retailerCard.content}
          </p> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[16px] leading-tight" />
          }}>
            {retailerCard.content}
          </ReactMarkdown>
          <X.Button
            secondary href="/retail"
            label={retailerCard.cta}
          // label={tr(data.retailCard.cta)}
          />
        </div>
        <div className="relative   min-w-[123px] h-[123px] shrink-0">
          <X.Image
            src={retailerCard.picture.url}
            fill
            alt="Merchants"
            className="object-cover object-center rounded-xl"
            unoptimized
          />
        </div>


      </div>
      {/* <X.Image
          // src={MerchantsMobileImage}
          src={retailerCard.picture.url}
          width={retailerCard.picture.width}
          height={retailerCard.picture.height}
          unoptimized
          alt="Merchants"
          className="h-[123px] w-auto"
        /> */}
    </div>
  );
}
